import { render } from "./AxisSettings.vue?vue&type=template&id=b7057c3c&scoped=true"
import script from "./AxisSettings.vue?vue&type=script&lang=js"
export * from "./AxisSettings.vue?vue&type=script&lang=js"

import "./AxisSettings.vue?vue&type=style&index=0&id=b7057c3c&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-b7057c3c"

export default script